import {
  BasketGroupSortType,
  SortDirection,
} from 'graphql-api/baskets-api-interfaces';

export enum BasketValidationStatus {
  Invalid,
  Valid,
}

export const CBASKET_NAMESPACE = 'cbasket';

export enum CBasketConfigurationKeys {
  Actions = 'actions',
  AddressLineTitleProperties = 'address-line-title-properties',
  AllowedMixedBasket = 'allowed-mixed-basket',
  AllowResendOrderConfirmation = 'allow-resend-order-confirmation',
  AlternativeAddressTitleType = 'alternative-address-title-type',
  AuxGroupingFn = 'aux-grouping-fn',
  BasketColumns = 'basket-columns',
  BasketDownloadFormat = 'basketDownloadFormat',
  BasketPolling = 'basket-polling',
  BasketUploadSkuLimit = 'basket-upload-sku-limit',
  BasketUploadRegardlessPreset = 'basket-upload-regardless-preset',
  CheckoutAdjustMessageDelay = 'checkout-adjust-message-delay',
  CopyNowBasketEnabled = 'copy-now-basket-enabled',
  CopyProductsAllowedOrderTypes = 'copy-products-allowed-order-types',
  CopyProductsEnabled = 'copy-products-enabled',
  DefaultSorting = 'default-sorting',
  DeliveryLevelCustomOrderReference = 'delivery-level-custom-order-reference',
  EnableBasketDeletion = 'basket-deletion',
  EnableBasketInsights = 'basket-insights',
  EnableBasketName = 'basket-name',
  EnableCopy = 'copy',
  EnableReschedule = 'reschedule',
  FutureDeliveryDateFormat = 'future-delivery-date-format',
  GroupByOptions = 'group-by-options',
  GroupedProductTitleShape = 'grouped-product-title-shape',
  HeaderLevelCustomOrderReference = 'header-level-custom-order-reference',
  HideProductTitleInArticle = 'hide-product-title-in-article',
  HighlightCloseoutProducts = 'highlight-closeout-products',
  ManualDiscounts = 'manual-discounts',
  ManualDiscountAppliedToSelected = 'manual-discount-applied-to-selected',
  ManualDiscountPercentageEntries = 'manual-discount-percentage-entries',
  MaxDiscountPercentage = 'max-discount-percentage',
  MaxOrderRefLength = 'maxOrderRefLength',
  MoveBasketEnabled = 'move-basket-enabled',
  OrderSuccessStaticImage = 'order-success-static-image',
  OrderSuccessThanksAccountName = 'order-success-thanks-account-name',
  ParkingOptionsEnabled = 'parking-options-enabled',
  PoNumberRequired = 'po-number-required',
  PropertyBagDropdowns = 'property-bag-dropdowns',
  PrepackTitleSuffixEnabled = 'prepack-title-suffix-enabled',
  PreselectPropertyBag = 'preselect-property-bag',
  PreviewSizes = 'preview-sizes',
  ProductIdShape = 'product-id-shape',
  ProductPropsFixModal = 'product-props-fix-modal',
  RemoveAllBackorderItemsEnabled = 'remove-all-backorder-items-enabled',
  RemoveErrorItemsEnabled = 'remove-error-items-enabled',
  RestrictMixedBasketDropShip = 'restrict-mixed-basket-dropship',
  ReuseDuringEmail = 'reuse-during-email',
  ShippingOptionEnabled = 'shipping-option-enabled',
  ShippingOptionUsePreferred = 'shipping-option-use-preferred',
  ShipInFullEnabled = 'ship-in-full-enabled',
  ShipToInfo = 'ship-to-info',
  ShopLevelCustomOrderReference = 'shop-level-custom-order-reference',
  ShowBasketManualDiscountInputForGroupTypes = 'show-basket-manual-discount-input-for-group-types',
  ShowBasketNotes = 'show-basket-notes',
  ShowConfirmedOrderNumber = 'show-confirmed-order-number',
  ShowDeliveryLinePrefixTitle = 'show-delivery-line-prefix-title',
  ShowIdInArticleGroup = 'show-id-in-article-group',
  ShowPrepackNote = 'show-prepack-note-basket', // because of the BE bug we cant create rule with the same name as in config strip namespace
  ShowRequestedOnPlacedColumns = 'show-requested-on-placed-columns',
  SortingPerGroup = 'sorting-per-group',
  UploadMDOBasketEnabled = 'upload-mdo-basket-enabled',
  UploadSDOBasketEnabled = 'upload-sdo-basket-enabled',
  UserRolesAllowedToSeeManualDiscountsInNewishBasket = 'user-roles-allowed-to-see-manual-discounts-in-newish-basket',
  BasketHeaderInfo = 'basket-header-info',
  ShowDropShipNote = 'show-drop-ship-note',
  ShowButtonsRowInBasket = 'show-buttons-row-in-basket',
  ValidatorBasketFunctions = 'validator-basket-functions',
  CheckEveryGrossPriceForManualDiscount = 'check-every-gross-price-for-manual-discount',
  UserFeedbackEnabled = 'user-feedback-enabled',
  UserFeedbackWriteEffectEnabled = 'user-feedback-write-effect-enabled',
  DisableEditBasketOnReview = 'disable-edit-basket-on-review',
  PendingBasketsAlert = 'pending-baskets-alert',
  DropShipConfirmText = 'drop-ship-confirm-text',
}

export interface SortParams {
  type: BasketGroupSortType;
  direction: SortDirection;
}
